import { useAppSelector } from "store/store";

const useShowPasswordInfo = () => {
  const user = useAppSelector(state => state.profile.user);

  return user?.showPasswordInfo || false;
};

export default useShowPasswordInfo;
